// extracted by mini-css-extract-plugin
export default {"rulePopupContainer":"styleModule_rulePopupContainer__20l8u","container":"styleModule_container__n95sU","card":"styleModule_card__1cMlc"};